<div class="flyout" (clickOutside)="closeFlyout()">
  <button class="username g-ellipsis-text" (click)="toggle()" [disabled]="settings.disable">
    <app-icon [svgIcon]="IconsEnum.user"></app-icon>
    <span class="label">{{ settings.title }}</span>
    <app-icon [svgIcon]="IconsEnum.chevron_down"></app-icon>
  </button>
  <div class="box" *ngIf="isOpen">
    <div *ngFor="let item of settings.items" (click)="selectItem(item)" class="box__item g-ellipsis-text" [ngClass]="{ 'g-disabled': item.disabled }">
      {{ item[settings.labelKey] }}
    </div>
  </div>
</div>
